"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("../../fragments/users");
const featureFlagsDetailData_1 = require("../../fragments/featureFlagsDetailData");
exports.workspaces = graphql_tag_1.default `
  query workspacesQuery(
    $skip: Int,
    $take: Int,
    $searchQuery: String
  ) {
    workspacesCount(
      searchQuery: $searchQuery
    )
    workspaces(
      skip: $skip,
      take: $take,
      searchQuery: $searchQuery
    ) {
      id
      name
      archived
      createdAt
      enableSubscriberTools
      updatedAt
      enabledIntegrationClasses
    }
  }
`;
exports.workspace = graphql_tag_1.default `
  query workspace($id: ID!) {
    workspace(id: $id) {
      id
      name
      createdAt
      updatedAt
      archived
      isUserAnalyticsEnabled
      isWorkspaceAnalyticsEnabled
      enableSubscriberTools
      enabledIntegrationClasses
      dashboardUrls
      helpLink
      agreedToTermsOfServiceUser {
        ...basicUserDetailData
      }
      agreedToTermsOfServiceDate
      featureFlagOverrides {
        ...featureFlagsDetailData
      }
    }
  }
  ${users_1.basicUserDetailData}
  ${featureFlagsDetailData_1.featureFlagsDetailData}
`;
exports.workspacesWithUserCounts = graphql_tag_1.default `
  query workspacesWithUserCounts(
    $skip: Int,
    $take: Int,
    $searchQuery: String
  ) {
    workspacesCount(
      searchQuery: $searchQuery
    )
    workspaces(
      skip: $skip,
      take: $take,
      searchQuery: $searchQuery
    ) {
      id
      name
      createdAt
      updatedAt
      enabledIntegrationClasses
      membershipCount
      enableSubscriberTools
    }
  }
`;
//# sourceMappingURL=workspaces.js.map